import mori from 'mori';
import buildTableData
  from '../../../datacenter/app/js/services/tableData';
import getFootnotes from '../../../datacenter/app/js/services/getFootnotes/';
import footnoteCallback from '../../../datacenter/app/js/services/getFootnotes/footnoteCallback';
import buildMapFromTimeframe
  from '../../../datacenter/app/js/services/mapData';
import getSelectedDistributions
  from '../../../datacenter/app/js/services/getSelectedDistributions';
import { renderNotes }
  from '../../../datacenter/app/js/services/renderData';

/**
 * Update map/table data as needed
 * @param  {Object} state current state, needs to have filteredData,
 *                        combinedFilter, isMultiGeo, type attached
 * @return {Object}       data updates
 */
export default function updateData(state, update = {}) {
  const tableProps = {};
  let datamapProps = null;
  const {
    filteredData,
    filteredMetaData,
    combinedFilters,
    isMultiGeo,
    type,
    tableIndex,
  } = state;

  if (!filteredData || !combinedFilters || !type) {
    /* eslint-disable */
    console.error = console.error || console.log || function log() {};
    console.error('Something happened, updateData() should only be called after data has been ran loaded properly');
    /* eslint-enable */
    return {};
  }

  const footnotes = getFootnotes(
    state,
    filteredMetaData,
    update,
    filteredData,
    combinedFilters
  );

  const notes = renderNotes(
    state.config,
    state.timeframes,
    update
  );

  function footnoteCb(key) {
    return footnoteCallback(
      key,
      footnotes.labeledFootnotes,
      !!(update.currentTimeframe && update.startTimeframe)
    );
  }

  tableProps.footnoteCallback = footnoteCb;
  tableProps.baseColumnContext = state.baseContext;
  tableProps.geomulti = state.globalRules.Geomulti;

  if ('all' === type || 'table' === type) {
    buildTableData.bind(tableProps)(
      state,
      filteredMetaData,
      update,
      filteredData,
      [
        mori.set(), // All columns
        mori.concat(
          mori.vector(state.combinedFilters[4][0]),
          getSelectedDistributions(
            state,
            filteredMetaData,
            filteredMetaData.immutableDistributions,
            state.globalSettings.hasDataviews &&
              !mori.getIn(state.config, ['globalRules', 'Locked'], false) ?
                mori.nth(filteredMetaData.immutableDataviews, 0) :
                false
          )),
        filteredMetaData.immutableDistributions,
        combinedFilters[3],
        combinedFilters[4],
      ],
      () => {}, // Ready callback... (not neede right now)
      combinedFilters[0], // Selected Keys
      isMultiGeo,
      () => {}, // render.getFootnotes
      () => {},
      tableIndex
    );
  }

  if ('all' === type || 'map' === type) {
    datamapProps = buildMapFromTimeframe(
      state,
      filteredMetaData,
      update,
      false, // Represents the treeContextSlug in Datacenter - not needed here.
      filteredData,
      ...state.combinedFilters
    );
  }

  tableProps.notes = notes;
  tableProps.footnotes = (mori.toJs(footnotes.filteredFootnotes) || [])
    .reduce((acc, curr) => {
      if (acc.filter(({ id }) => id === curr.id).length) {
        return acc;
      }
      acc.push(curr);
      return acc;
    }, [])
    .sort(({ weight: a }, { weight: b }) => a - b);

  return {
    table: tableProps,
    datamap: datamapProps,
  };
}



// WEBPACK FOOTER //
// ./app/services/updateData.js